import { render } from "./FileUploadSettings.vue?vue&type=template&id=f727ac2e"
import script from "./FileUploadSettings.vue?vue&type=script&lang=js"
export * from "./FileUploadSettings.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Serik/Job/qbox-transcriber-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__